import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// const hotels = [
//   { hotel: "Citymax Hotel Bur Dubai", address: "Citymax Hotel, Bur Dubai, Mankhool and Kuwait Street, Dubai, UAE" },
//   { hotel: "Grand Excelsior Hotel Bur Dubai", address: "Al Kuwait St, Bur Dubai, Dubai, United Arab Emirates" },
//   { hotel: "Wescott Hotel Bur Dubai", address: "P.O. Box 32795, Al Souq Al Kabeer, Bur Dubai, Dubai, United Arab Emirates" },
//   { hotel: "Admiral Plaza Hotel Bur Dubai", address: "Khalid Bin Walid Road, Al Nahdha Street, Bur Dubai, Dubai, UAE (PO Box 26888)" },
//   { hotel: "Park Regis Hotel Bur Dubai", address: "Near Burjuman Metro Station, Khalid Bin Al Waleed St, Bur Dubai, Dubai, UAE" },
//   { hotel: "Double Tree By Hilton Bur Dubai", address: "Al Mankhool Road, Bur Dubai, Dubai, UAE" },
//   { hotel: "Regent Palace Hotel Al Karama", address: "Khalid Bin Al Waleed Rd, Al Karama, Dubai, UAE" },
//   { hotel: "Fortune Karama Hotel", address: "Near Karama Metro Station, 2 17A St, Al Karama, Dubai, UAE" },
//   { hotel: "Savoy Suites Hotel Apartments Bur Dubai", address: "Street #12, Mankhool, Bur Dubai, Dubai, UAE" },
//   {
//     "hotel": "DOLPHIN HOTEL BUR DUBAI",
//     "address": "Bur Dubai, UAE",
//   },
//   {
//     "hotel": "CITY MAX HOTEL BUR DUBAI",
//     "address": "Bur Dubai, UAE",
//   },
//   {
//     "hotel": "WESCOTT HOTEL BUR DUBAI",
//     "address": "Bur Dubai, UAE",
//   },
//   {
//     "hotel": "RAINTREE HOTEL BUR DUBAI",
//     "address": "Bur Dubai, UAE",
//   },
//   {
//     "hotel": "FORTUNE PEARL DEIRA DUBAI",
//     "address": "Deira Dubai, UAE",
//   },
//   {
//     "hotel": "SIGNATURE HOTEL DEIRA DUBAI",
//     "address": "Deira Dubai, UAE",
//   },
//   {
//     "hotel": "ORCHID HOTEL DEIRA DUBAI",
//     "address": "Deira Dubai, UAE",
//   },
//   {
//     "hotel": "ROYAL TULIP HOTEL DEIRA DXB",
//     "address": "Deira Dubai, UAE",
//   },
//   {
//     "hotel": "GEVORA HOTEL (D.T DXB)",
//     "address": "Downtown Dubai, UAE",
//   },
//   {
//     "hotel": "FOUR POINT SHERATON (D.T)",
//     "address": "Downtown Dubai, UAE",
//   },
//   {
//     "hotel": "SUNDAY INT HOLIDAY (D.T)",
//     "address": "Downtown Dubai, UAE",
//   },
//   {
//     "hotel": "FOUR POINT BY SHERATON",
//     "address": "Bur Dubai, UAE",
//   },
//   {
//     "hotel": "ROYAL ASCOTT HOTEL B.D",
//     "address": "Bur Dubai, UAE",
//   },
//   {
//     "hotel": "SEA VIEW HOTEL BUR DUBAI",
//     "address": "Bur Dubai, UAE",
//   },
//   {
//     "hotel": "SUNDAY HOLIDAY BUR DUBAI",
//     "address": "Bur Dubai, UAE",
//   },
//   {
//     "hotel": "RAMADA BY WHYNDAM DEIRA",
//     "address": "Deira Dubai, UAE",
//   },
//   {
//     "hotel": "VERSALIS BY VIRAS DEIRA DUBAI",
//     "address": "Deira Dubai, UAE",
//   },
//   {
//     "hotel": "FORTUNE GRAND DEIRA DUBAI",
//     "address": "Deira Dubai, UAE",
//   },
//   {
//     "hotel": "SAFFORAN BATIQUE DEIRA DXB",
//     "address": "Deira Dubai, UAE",
//   },
//   {
//     "hotel": "PARK REGIS HOTEL BUR DUBAI",
//     "address": "Bur Dubai, UAE",
//   },
//   {
//     "hotel": "DOUBLE TREE BY HILTON B.D",
//     "address": "Bur Dubai, UAE",
//   },
//   {
//     "hotel": "THE CANVAS HOTEL BUR DUBAI",
//     "address": "Bur Dubai, UAE",
//   },
//   {
//     "hotel": "KNIGHT CASTLE DEIRA DUBAI",
//     "address": "Deira Dubai, UAE",
//   },
//   {
//     "hotel": "AVANI HOTEL DEIRA DUBAI",
//     "address": "Deira Dubai, UAE",
//   },
//   {
//     "hotel": "CROWN PLAZA DEIRA DUBAI",
//     "address": "Deira Dubai, UAE",
//   },
//   {
//     "hotel": "ANANTARA HOTEL D.T DXB",
//     "address": "Downtown Dubai, UAE",
//   },
//   {
//     "hotel": "WESTMINSTER DXB MALL",
//     "address": "Downtown Dubai, UAE",
//   },
//   {
//     "hotel": "SOFITEL DOWNTOWN DXB",
//     "address": "Downtown Dubai, UAE",
//   },
//   {
//     "hotel": "Holiday Inn YEREVAN - REPUBLIC SQUARE",
//     "address": "uploads/hotelImage/1769760514040-292240331.jpg",
//   },
//   {
//     "hotel": "voco: Dubai",
//     "address": "Downtown Dubai, UAE",
//   },
// ];

const hotels = [
  { hotel: "Admiral Plaza Hotel Bur Dubai", address: "Khalid Bin Walid Road, Al Nahdha Street, Bur Dubai, Dubai, UAE (PO Box 26888)" },
  { hotel: "ANANTARA HOTEL D.T DXB", address: "Downtown Dubai, UAE" },
  { hotel: "AVANI HOTEL DEIRA DUBAI", address: "Deira Dubai, UAE" },
  { hotel: "CITY MAX HOTEL BUR DUBAI", address: "Bur Dubai, UAE" },
  { hotel: "Citymax Hotel Bur Dubai", address: "Citymax Hotel, Bur Dubai, Mankhool and Kuwait Street, Dubai, UAE" },
  { hotel: "CROWN PLAZA DEIRA DUBAI", address: "Deira Dubai, UAE" },
  { hotel: "DOLPHIN HOTEL BUR DUBAI", address: "Bur Dubai, UAE" },
  { hotel: "DOUBLE TREE BY HILTON B.D", address: "Bur Dubai, UAE" },
  { hotel: "Double Tree By Hilton Bur Dubai", address: "Al Mankhool Road, Bur Dubai, Dubai, UAE" },
  { hotel: "FORTUNE GRAND DEIRA DUBAI", address: "Deira Dubai, UAE" },
  { hotel: "FORTUNE KARMA HOTEL", address: "Near Karama Metro Station, 2 17A St, Al Karama, Dubai, UAE" },
  { hotel: "FORTUNE PEARL DEIRA DUBAI", address: "Deira Dubai, UAE" },
  { hotel: "FOUR POINT BY SHERATON", address: "Bur Dubai, UAE" },
  { hotel: "FOUR POINT SHERATON (D.T)", address: "Downtown Dubai, UAE" },
  { hotel: "GEVORA HOTEL (D.T DXB)", address: "Downtown Dubai, UAE" },
  { hotel: "Grand Excelsior Hotel Bur Dubai", address: "Al Kuwait St, Bur Dubai, Dubai, United Arab Emirates" },
  { hotel: "Holiday Inn YEREVAN - REPUBLIC SQUARE", address: "uploads/hotelImage/1769760514040-292240331.jpg" },
  { hotel: "KNIGHT CASTLE DEIRA DUBAI", address: "Deira Dubai, UAE" },
  { hotel: "ORCHID HOTEL DEIRA DUBAI", address: "Deira Dubai, UAE" },
  { hotel: "PARK REGIS HOTEL BUR DUBAI", address: "Bur Dubai, UAE" },
  { hotel: "Park Regis Hotel Bur Dubai", address: "Near Burjuman Metro Station, Khalid Bin Al Waleed St, Bur Dubai, Dubai, UAE" },
  { hotel: "RAINTREE HOTEL BUR DUBAI", address: "Bur Dubai, UAE" },
  { hotel: "RAMADA BY WHYNDAM DEIRA", address: "Deira Dubai, UAE" },
  { hotel: "Regent Palace Hotel Al Karama", address: "Khalid Bin Al Waleed Rd, Al Karama, Dubai, UAE" },
  { hotel: "ROYAL ASCOTT HOTEL B.D", address: "Bur Dubai, UAE" },
  { hotel: "ROYAL TULIP HOTEL DEIRA DXB", address: "Deira Dubai, UAE" },
  { hotel: "SAFFORAN BATIQUE DEIRA DXB", address: "Deira Dubai, UAE" },
  { hotel: "Savoy Suites Hotel Apartments Bur Dubai", address: "Street #12, Mankhool, Bur Dubai, Dubai, UAE" },
  { hotel: "SEA VIEW HOTEL BUR DUBAI", address: "Bur Dubai, UAE" },
  { hotel: "SIGNATURE HOTEL DEIRA DUBAI", address: "Deira Dubai, UAE" },
  { hotel: "SOFITEL DOWNTOWN DXB", address: "Downtown Dubai, UAE" },
  { hotel: "SUNDAY HOLIDAY BUR DUBAI", address: "Bur Dubai, UAE" },
  { hotel: "SUNDAY INT HOLIDAY (D.T)", address: "Downtown Dubai, UAE" },
  { hotel: "THE CANVAS HOTEL BUR DUBAI", address: "Bur Dubai, UAE" },
  { hotel: "VERSALIS BY VIRAS DEIRA DUBAI", address: "Deira Dubai, UAE" },
  { hotel: "Voco: Dubai", address: "Downtown Dubai, UAE" },
  { hotel: "WESCOTT HOTEL BUR DUBAI", address: "Bur Dubai, UAE" },
  { hotel: "Wescott Hotel Bur Dubai", address: "P.O. Box 32795, Al Souq Al Kabeer, Bur Dubai, Dubai, United Arab Emirates" },
  { hotel: "WESTMINSTER DXB MALL", address: "Downtown Dubai, UAE" },
  { hotel: "Royal Plaza by Stellar Hotels, Yerevan", address: "9 Tumanyan Street, Yerevan 0002, Armenia"},
  { hotel: "DoubleTree by Hilton Hotel Yerevan City Centre", address: "4 Grigor Lusavorich Street, Yerevan 0015, Armenia"},
  { hotel: "Ramada Hotel & Suites by Wyndham Yerevan", address: "15 Pavstos Buzand Street, Yerevan 0010, Armenia"},
  { hotel: "Ani Grand Hotel Yerevan", address: "65 Abovyan Street, Yerevan 0001, Armenia"},
  { hotel: "Europe Hotel Yerevan", address: "38 Hanrapetutyan Street, Yerevan 0010, Armenia"},
  { hotel: "Radisson Blu Hotel, Yerevan", address: "2 Azatutyan Avenue, Yerevan 0037, Armenia" }

];


export default function HotelInvoiceForm({ onSubmit }) {
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);


  const [formData, setFormData] = useState({
    hotel: "",
    address: "",
    name: "",
    checkin: "",
    checkout: "",
    price: "",
  });
  const [loading, setLoading] = useState(false);
  const [passengers, setPassengers] = useState([]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  useEffect(() => {
    const fetchPassengers = async () => {
      try {
        const res = await fetch("https://api.pdf.tajgateways.com/api-v1/users/get-pdfs");
        const data = await res.json();
        if (data.code === 200) {
          setPassengers(data.data);
        } else {
          toast.error("❌ Failed to load passengers");
        }
      } catch (err) {
        console.error("Error fetching passengers:", err);
        toast.error("❌ Error fetching passengers");
      }
    };
    fetchPassengers();
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = { type: "hotel", ...formData };
    console.log("🚀 Payload sending to backend:", payload);

    try {
      const res = await fetch("https://api.pdf.tajgateways.com/api-v1/users/convert-pdf", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      console.log("Response:", data);

      if (data.code === 200) {
        toast.success("✅ Form submitted successfully!");
        navigate("/");
      } else {
        toast.error("❌ Failed to submit form!");
      }

      onSubmit();
    } catch (err) {
      console.error("Error submitting form:", err);
      toast.error("❌ Failed to submit form, please try again!");
    } finally {
      setLoading(false);
    }
  };

  const isMobile = windowWidth < 600;
  const isTablet = windowWidth >= 600 && windowWidth < 992;


  return (
    <div
      style={{
        ...styles.container,
        flexDirection: isMobile ? "column" : "row",
        padding: isMobile ? "20px" : "40px",
      }}
    >
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Dashboard Button */}
      <div
        style={{
          position: "absolute",
          top: isMobile ? "10px" : "20px",
          right: isMobile ? "10px" : "20px",
        }}
      >
        <button
          type="button"
          style={{
            ...styles.dashboardBtn,
            padding: isMobile ? "6px 10px" : "8px 14px",
            fontSize: isMobile ? "12px" : "14px",
          }}
          onClick={() => navigate("/")}
        >
          📊 Dashboard
        </button>
      </div>

      {/* Form */}
      <form
        style={{
          ...styles.form,
          width: isMobile ? "90%" : isTablet ? "60%" : "400px",
          padding: isMobile ? "20px" : "30px",
          gap: isMobile ? "12px" : "15px",
          position: "relative",
          top: isMobile ? "50px" : "100px",
        }}
        onSubmit={handleSubmit}
      >
        <div style={styles.header}>
          <h3
            style={{
              ...styles.title,
              fontSize: isMobile ? "18px" : "22px",
              textAlign: "center",
              width: "100%",
            }}
          >
            🏨 Hotel Invoice
          </h3>
        </div>

        <input
          style={{
            ...styles.input,
            fontSize: isMobile ? "13px" : "14px",
            padding: isMobile ? "10px" : "12px",
          }}
          list="passenger-list"
          name="name"
          placeholder="Enter or select guest"
          value={formData.name}
          onChange={(e) => {
            const guestName = e.target.value;
            setFormData({ ...formData, name: guestName });
            const selectedPassenger = passengers.find((p) => p.name === guestName);
            if (selectedPassenger) {
              setFormData((prev) => ({
                ...prev,
                checkin: formatDate(selectedPassenger.departureDate || selectedPassenger.date),
                checkout:
                  selectedPassenger.type === "roundtrip"
                    ? formatDate(selectedPassenger.returnDate || selectedPassenger.flightDate2)
                    : "",
              }));
            } else {
              setFormData((prev) => ({ ...prev, checkin: "", checkout: "" }));
            }
          }}
          required
        />
        <datalist id="passenger-list">
          {passengers.map((p) => (
            <option key={p._id} value={p.name} />
          ))}
        </datalist>

        <select
          style={{
            ...styles.input,
            fontSize: isMobile ? "13px" : "14px",
            padding: isMobile ? "10px" : "12px",
          }}
          name="hotel"
          onChange={(e) => {
            const selectedHotel = hotels.find((h) => h.hotel === e.target.value);
            setFormData({
              ...formData,
              hotel: selectedHotel?.hotel || "",
              address: selectedHotel?.address || "",
            });
          }}
          required
          value={formData.hotel}
        >
          <option value="">Select Hotel</option>
          {hotels.map((h) => (
            <option key={h.hotel} value={h.hotel}>
              {h.hotel}
            </option>
          ))}
        </select>

        <input
          style={{
            ...styles.input,
            background: "#f9f9f9",
            cursor: "not-allowed",
            fontSize: isMobile ? "13px" : "14px",
          }}
          name="address"
          placeholder="Hotel Address"
          value={formData.address}
          readOnly
        />

        <label style={styles.label}>Check-in:</label>
        <input
          style={{ ...styles.input, fontSize: isMobile ? "13px" : "14px" }}
          type="date"
          name="checkin"
          onChange={handleChange}
          value={formData.checkin}
          required
        />

        <label style={styles.label}>Check-out:</label>
        <input
          style={{ ...styles.input, fontSize: isMobile ? "13px" : "14px" }}
          type="date"
          name="checkout"
          onChange={handleChange}
          value={formData.checkout}
          required
        />

        <input
          style={{ ...styles.input, fontSize: isMobile ? "13px" : "14px" }}
          type="number"
          name="price"
          placeholder="Price (INR)"
          onChange={handleChange}
          value={formData.price}
          required
        />

        <button
          style={{
            ...styles.button,
            fontSize: isMobile ? "14px" : "15px",
            padding: isMobile ? "10px" : "12px",
          }}
          type="submit"
          disabled={loading}
        >
          {loading ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <div style={styles.loader}></div> Submitting...
            </div>
          ) : (
            "Submit"
          )}
        </button>
      </form>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "90vh",
    background: "#f4f6f9",
    position: "relative",
  },
  form: {
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
    display: "flex",
    flexDirection: "column",
  },
  header: { marginBottom: "15px" },
  title: { margin: 0, color: "#2c3e50", fontWeight: "600" },
  dashboardBtn: {
    background: "#3498db",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "500",
    marginRight: "0px",
  },
  input: {
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    outline: "none",
    transition: "0.3s",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#2c3e50",
    marginBottom: "-10px",
    marginLeft: "5px",
  },
  button: {
    background: "#3498db",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "500",
    transition: "0.3s",
  },
  loader: {
    border: "2px solid #f3f3f3",
    borderTop: "2px solid #fff",
    borderRadius: "50%",
    width: "14px",
    height: "14px",
    animation: "spin 1s linear infinite",
  },
};

// Add spin animation globally
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;
document.head.appendChild(styleSheet);
